import script from "./sub-designation.vue?vue&type=script&setup=true&lang=ts"
export * from "./sub-designation.vue?vue&type=script&setup=true&lang=ts"

import "./sub-designation.vue?vue&type=style&index=0&id=7f8b9422&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f8b9422"]])

export default __exports__